// Base URL for the backend-java API
export const API_BASE_URL = 'https://get-started-anime-gzdr.onrender.com' // Update with your backend-java's URL
